function e(o){return o instanceof Promise}export{e as a};
